import { Text } from '@leroy-merlin-br/backyard-react'

import { OfferSchema } from 'shared/schemas/OfferSchema'

import { PriceTagLabel } from '../PriceTagLabel'
import { PriceDiscount, PriceInstallments, PriceTagUnavailable } from './'
import * as S from './styled'

interface PriceTag {
  isAssistedSale: boolean
  isOnDemand: boolean
  isOfferSchemaEnabled: boolean
  isOutlet: boolean
  isSoldOut: boolean
  hidePrice: boolean
  brandedInstallmentsAmount: number
  installments: {
    amount: number
    value: string
  }
  discountPercentage: number
  discountType: string
  paymentMethodsDiscount: string
  unit: string
  price: {
    from?: {
      integers: string
      decimals: string
    }
    region?: {
      integers: string
      decimals: string
    }
    to: {
      integers: string
      decimals: string
    }
  }
  packaging: {
    unit: string
    quantity: string
    label: string
    price: {
      integers: string
      decimals: string
    }
  }
}

const PriceTag = ({
  isAssistedSale,
  isOnDemand,
  isOfferSchemaEnabled,
  isOutlet,
  isSoldOut,
  hidePrice,
  brandedInstallmentsAmount,
  installments,
  discountPercentage,
  discountType,
  paymentMethodsDiscount,
  unit,
  price,
  packaging
}: PriceTag) => {
  const isUnavailable = hidePrice || isSoldOut

  if (isUnavailable) {
    return (
      <S.PriceTag isUnavailable>
        {isOfferSchemaEnabled && (
          <OfferSchema
            availability="OutOfStock"
            productUrl={(window as any).location.href}
            productPrice={price.to}
          />
        )}

        <PriceTagUnavailable
          hidePrice={hidePrice}
          isAssistedSale={isAssistedSale}
        />
      </S.PriceTag>
    )
  }

  const isOffer = Boolean(price.from)
  const isDiscountByPaymentMethod = discountType === 'payment-method'

  return (
    <S.PriceTag
      isOutlet={isOutlet}
      isPromotional={isOffer && !isDiscountByPaymentMethod}
      isPromotionalByPaymentMethod={isOffer && isDiscountByPaymentMethod}
    >
      {isOfferSchemaEnabled && (
        <OfferSchema
          availability={isOnDemand ? 'LimitedAvailability' : 'InStock'}
          productUrl={(window as any).location.href}
          productPrice={price.to}
        />
      )}

      <PriceTagLabel
        isOutlet={isOutlet}
        isOffer={isOffer}
        isDiscountByPaymentMethod={isDiscountByPaymentMethod}
        paymentMethodsDiscount={paymentMethodsDiscount}
        discountPercentage={discountPercentage}
      />

      <S.Price>
        <PriceDiscount isOutlet={isOutlet} price={price?.region} unit={unit} />
        <PriceDiscount isOutlet={isOutlet} price={price?.from} unit={unit} />
        <div>
          <S.TotalPrice data-cy="product-price-integer">
            R$ {price.to.integers},{price.to.decimals}
          </S.TotalPrice>
          <span data-cy="product-price-decimal"> /{unit}</span>
        </div>
      </S.Price>

      {packaging && (
        <S.PackagingPrice>
          <Text as="strong" isBold noMargin>
            R${packaging.price.integers},{packaging.price.decimals} /{' '}
            {packaging.label}
          </Text>

          <S.Dot />

          <Text as="span" noMargin>
            cada {packaging.label} possui {packaging.quantity.replace('.', ',')}
            {packaging.unit}
          </Text>
        </S.PackagingPrice>
      )}

      <PriceInstallments
        installments={{
          amount: installments.amount,
          value: installments.value
        }}
      />

      <PriceInstallments
        installments={{
          amount: brandedInstallmentsAmount,
          value: ''
        }}
        isBranded
      />
    </S.PriceTag>
  )
}

export default PriceTag
